import { createAction } from 'redux-actions';
import { isNotEmptyString } from '../utils';
import {PARAM_EMAIL, PARAM_MAIL_FROM} from '../constants';

export const SET_EMAIL = 'MAIN_SET_EMAIL';
export const SET_MOBILE = 'SET_MOBILE';
export const VALIDATE_USERNAME = 'MAIN_VALIDATE_USERNAME';
export const SET_EMAIL_VALIDATION_DATA = 'MAIN_SET_EMAIL_VALIDATION_DATA';
export const SET_HAS_PROMO = 'MAIN_SET_HAS_PROMO';
export const SET_USERNAME_VALIDATION_DATA = 'MAIN_SET_USERNAME_VALIDATION_DATA';
export const SUBMIT_CLIENT_FROM_SHOP = 'SUBMIT_CLIENT_FROM_SHOP';
export const VALIDATE_MOBILE = 'MAIN_VALIDATE_MOBILE';
export const SET_TELEPHONE_VALIDATION = 'MAIN_SET_TELEPHONE_VALIDATION';
export const SET_CLIENT_ID = 'MAIN_SET_CLIENT_ID';
export const SET_SMS_ERROR = 'MAIN_SET_SMS_ERROR';
export const SET_ERROR_MESSAGE = 'MAIN_SET_ERROR_MESSAGE';
export const FINISH_LOGIN_DONE = 'MAIN_FINISH_LOGIN_DONE';
export const CHANGE_USERNAME = 'MAIN_CHANGE_USERNAME';
export const CHANGE_PASSWORD = 'MAIN_CHANGE_PASSWORD';
export const CHANGE_FIRST_NAME = 'MAIN_CHANGE_FIRST_NAME';
export const CHANGE_SURNAME = 'MAIN_CHANGE_SURNAME';
export const CHANGE_BIRTH_DATE = 'MAIN_CHANGE_BIRTH_DATE';
export const VALIDATE_FORM_SUCCESS = 'VALIDATE_FORM_SUCCESS';
export const VALIDATE_FORM_ERROR = 'VALIDATE_FORM_ERROR';
export const MAIN_HANDLE_PENDING_STATUS = 'MAIN_HANDLE_PENDING_STATUS';
export const MAIN_VALIDATE_FORM = 'MAIN_VALIDATE_FORM';
export const RESEND_ACTIVATION_LINK = 'MAIN_RESEND_ACTIVATION_LINK';
export const SET_SUCCESSFUL_ACTIVATION = 'MAIN_SET_SUCCESSFUL_ACTIVATION';
export const SET_RESEND_ACTIVATION_DATA = 'MAIN_SET_RESEND_ACTIVATION_DATA';
export const VALIDATE_AGENT_PROMOTION = 'MAIN_VALIDATE_AGENT_PROMOTION';
export const SET_PROMOCODE_VALIDATION_DATA = 'MAIN_SET_PROMOCODE_VALIDATION_DATA';
export const SET_INVALID_PROMOCODE = 'SET_INVALID_PROMOCODE';
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
export const SEND_RECOVERY_PASSWORD = 'SEND_RECOVERY_PASSWORD';
export const SEND_RECOVERY_PASSWORD_SUCCESS = 'SEND_RECOVERY_PASSWORD_SUCCESS';
export const SEND_RECOVERY_PASSWORD_ERROR = 'SEND_RECOVERY_PASSWORD_ERROR';
export const CHANGE_PASSWORD_CONFIRM = 'CHANGE_PASSWORD_CONFIRM';
export const CHANGE_TERMS_STATUS = 'CHANGE_TERMS_STATUS';
export const DELETE_LOGIPARMA_DORMANT_CLIENT = 'DELETE_LOGIPARMA_DORMANT_CLIENT';
export const OPEN_DELETE_DORMANT_CLIENT_POPUP = 'OPEN_DELETE_DORMANT_CLIENT_POPUP';
export const CLOSE_DELETE_DORMANT_CLIENT_POPUP = 'CLOSE_DELETE_DORMANT_CLIENT_POPUP';
export const DELETE_LOGIPARMA_DORMANT_CLIENT_SUCCESS = 'DELETE_LOGIPARMA_DORMANT_CLIENT_SUCCESS';
export const DELETE_LOGIPARMA_DORMANT_CLIENT_ERROR = 'DELETE_LOGIPARMA_DORMANT_CLIENT_ERROR';
export const DELETE_BOLT_DORMANT_CLIENT = 'DELETE_BOLT_DORMANT_CLIENT';
export const DELETE_BOLT_DORMANT_CLIENT_SUCCESS = 'DELETE_BOLT_DORMANT_CLIENT_SUCCESS';
export const DELETE_BOLT_DORMANT_CLIENT_ERROR = 'DELETE_BOLT_DORMANT_CLIENT_ERROR';
export const GET_USER_AND_INACTIVE_INFO = 'GET_USER_AND_INACTIVE_INFO';

const initialState = {
  email: '',
  emailStatus: '',
  emailMessage: null,
  emailErrorCode: null,
  mobile: '',
  mobileMessage: '',
  mobileErrorCode: null,
  mobileUserInfo: null,
  clientId: '',
  promocode: '',
  fullPromocode: '',
  migrationParam: '',
  promocodeStatus: '',
  promocodeMessage: null,
  promocodeErrorCode: null,
  error: {},
  isFinish: '',
  stateError: '',
  username: '',
  usernameStatus: 'none',
  usernameMessage: '',
  password: '',
  passwordStatus: 'none',
  passwordErrorMessage: '',
  passwordConfirm: '',
  passwordConfirmStatus: 'none',
  firstname: '',
  firstnameStatus: 'none',
  firstnameErrorMessage: '',
  surname: '',
  surnameStatus: 'none',
  surnameErrorMessage: '',
  day: '-',
  month: '-',
  year: '-',
  dateStatus: 'none',
  dateErrorMessage: '',
  mailFrom: PARAM_MAIL_FROM,
  reactivationMessage: '',
  reactivationParam: '',
  reactivationStatus: '',
  reactivationCode: '',
  validationMessage: '',
  invalidPromocodeMessage: '',
  country: '',
  otpValid: null,
  agentId: server.agentId != null ? server.agentId : null,
  modalOpen: false,
  recoveryPasswordStatus: 0,
  isLoadingRecoveryPassword: false,
  recoveryPasswordMessage: '',
  isFormValidating: false,
  isLoadingPromocodeCheck: false,
  isLoadingMobileCheck: false,
  isLoadingUsernameCheck: false,
  isLoadingPasswordCheck: false,
  isLoadingFirstNameCheck: false,
  isLoadingSurnameCheck: false,
  isLoadingDateOfBirthCheck: false,
  termsStatus: '',
  deleteDormantClientStatus: 0,
  isLoadingDeleteDormantClient: false,
  deleteDormantClientMessage: '',
  deleteDormantClientEnabled: false,
};

export default function loyaltiesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload
      }
    case SET_MOBILE:
      return {
        ...state,
        mobile: action.payload
      }
    case SET_TELEPHONE_VALIDATION:
      return {
        ...state,
        isLoadingMobileCheck: false,
        isFormValidating: false,
        mobileMessage: action.payload.mobileMessage,
        mobileErrorCode: action.payload.mobileErrorCode,
        mobileUserInfo: action.payload.mobileUserInfo,
        deleteDormantClientEnabled: action.payload.mobileErrorCode === -21738
      }
    case SET_EMAIL_VALIDATION_DATA:
      return {
        ...state,
        emailStatus: action.payload.emailStatus,
        emailMessage: action.payload.emailMessage,
        emailErrorCode: action.payload.code,
        error: action.payload.emailStatus !== "error" ? {} : state.error,
      }
    case SET_PROMOCODE_VALIDATION_DATA:
      const setPromocodeValidationDataParams = {};

      if (action.payload.promocodeStatus != null) {
        setPromocodeValidationDataParams["promocodeStatus"] = action.payload.promocodeStatus;
      }

      if (action.payload.promocode != null) {
        setPromocodeValidationDataParams["promocode"] = action.payload.promocode;
      }

      if (action.payload.fullPromocode != null) {
        setPromocodeValidationDataParams["fullPromocode"] = action.payload.fullPromocode;
      }

      if (action.payload.migrationParam != null) {
        setPromocodeValidationDataParams["migrationParam"] = action.payload.migrationParam;
      }

      if (action.payload.promocodeMessage != null) {
        setPromocodeValidationDataParams["promocodeMessage"] = action.payload.promocodeMessage;
      }

      if (action.payload.code != null) {
        setPromocodeValidationDataParams["promocodeErrorCode"] = action.payload.code;
      }

      return {
        ...state,
        isLoadingPromocodeCheck: false,
        isFormValidating: false,
        agentId: action.payload.promocode,
        ...setPromocodeValidationDataParams
      }
    case SET_RESEND_ACTIVATION_DATA:
      return {
        ...state,
        reactivationMessage: action.payload.message,
        reactivationParam: action.payload.paramName,
        reactivationStatus: action.payload.status,
        reactivationCode: action.payload.code,
      }
    case SET_SUCCESSFUL_ACTIVATION: {
      const message = action.payload.paramName === PARAM_EMAIL ?
        'Activation link re-sent successfully. Please check your spam/trash folders and add @email to your approved senders list.'
        :
        'Activation link re-sent successfully. Please check your phone’s global Do Not Disturb and make sure you are opted out so you can receive the SMS.';

      if (action.payload.paramName === PARAM_EMAIL) {
        return {
          ...state,
          emailStatus: 'success',
          reactivationMessage: message,
          reactivationParam: action.payload.paramName,
          reactivationStatus: 'success',
          reactivationCode: 1,
        }
      } else {
        return {
          ...state,
          mobileMessage: 'success',
          reactivationMessage: message,
          reactivationParam: action.payload.paramName,
          reactivationStatus: 'success',
          reactivationCode: 1,
        }
      }
    }
    case SET_HAS_PROMO:
      return {
        ...state,
        promocode: action.payload.promocode !== undefined
            ? action.payload.promocode
            : state.promocode,
      }
    case SET_USERNAME_VALIDATION_DATA:
      return {
        ...state,
        usernameMessage: action.payload.usernameMessage,
      }
    case SET_CLIENT_ID:
      return {
        ...state,
        clientId: action.payload.clientId,
        mailFrom: action.payload.mailFrom,
      }
    case SET_SMS_ERROR:
      return {
        ...state,
        smsError: action.payload.error,
      }
    case SET_ERROR_MESSAGE: {
      const submitFromValidationErrors = action.payload.validationErrors;

      const errors = {};
      let validationMessage = '';

      if (submitFromValidationErrors != null) {
        if (submitFromValidationErrors.promocodeError) {
          errors.promocodeStatus = 'error';
          validationMessage = submitFromValidationErrors.promocodeError;
        }

        if (submitFromValidationErrors.emailError) {
          errors.emailStatus = 'error';
          validationMessage = submitFromValidationErrors.emailError;
        }

        if (submitFromValidationErrors.firstnameError) {
          errors.firstnameStatus = 'error';
          errors.firstnameMessage = submitFromValidationErrors.firstnameError;
        }

        if (submitFromValidationErrors.lastnameError) {
          errors.surnameStatus = 'error';
          errors.surnameMessage = submitFromValidationErrors.lastnameError;
        }

        if (submitFromValidationErrors.mobileError) {
          validationMessage = submitFromValidationErrors.mobileError;
        }

        if (submitFromValidationErrors.usernameError) {
          errors.usernameStatus = 'error';
          errors.usernameMessage = submitFromValidationErrors.usernameError;
        }

        if (submitFromValidationErrors.paramsCombinationError) {
          errors.firstnameStatus = 'error';
          errors.surnameStatus = 'error';
          errors.dateStatus = 'error';
          errors.firstnameMessage = submitFromValidationErrors.paramsCombinationError;
          validationMessage = submitFromValidationErrors.paramsCombinationError;
        }

        if (submitFromValidationErrors.passwordError) {
          errors.passwordStatus = 'error';
          errors.passwordMessage = submitFromValidationErrors.passwordError;
        }

        if (submitFromValidationErrors.birthDateError) {
          errors.dateStatus = 'error';
          errors.dateErrorMessage = submitFromValidationErrors.birthDateError;
        }
      }

      return {
        ...state,
        error: action.payload.error,
        firstnameStatus: errors.firstnameStatus ? errors.firstnameStatus : state.firstnameStatus,
        firstnameErrorMessage: errors.firstnameMessage ? errors.firstnameMessage : state.firstnameErrorMessage,
        surnameStatus: errors.surnameStatus ? errors.surnameStatus : state.surnameStatus,
        surnameErrorMessage: errors.surnameMessage ? errors.surnameMessage : state.surnameErrorMessage,
        usernameStatus: errors.usernameStatus ? errors.usernameStatus : state.usernameStatus,
        usernameMessage: errors.usernameMessage ? errors.usernameMessage : state.usernameMessage,
        passwordStatus: errors.passwordStatus ? errors.passwordStatus : state.passwordStatus,
        passwordErrorMessage: errors.passwordMessage ? errors.passwordMessage : state.passwordErrorMessage,
        dateStatus: errors.dateStatus ? errors.dateStatus : state.dateStatus,
        dateErrorMessage: errors.dateErrorMessage ? errors.dateErrorMessage : state.dateErrorMessage,
        validationMessage: validationMessage !== '' ? validationMessage : action.payload.error.message,
      }
    }
    case FINISH_LOGIN_DONE:
      return {
        ...state,
        isFinish: action.payload,
      }
    case VALIDATE_USERNAME:
      return {
        ...state,
        usernameMessage: '',
      }
    case CHANGE_USERNAME:
      return {
        ...state,
        username: action.payload.username != null ? action.payload.username : state.username,
        usernameStatus: action.payload.usernameStatus != null ? action.payload.usernameStatus : state.usernameStatus,
        usernameMessage: action.payload.usernameMessage != null ? action.payload.usernameMessage : state.usernameMessage
      }
    case CHANGE_PASSWORD:
      return {
        ...state,
        password: action.payload.password != null ? action.payload.password : state.password,
        passwordStatus: action.payload.passwordStatus != null ? action.payload.passwordStatus : state.passwordStatus,
        passwordErrorMessage: action.payload.passwordErrorMessage != null ? action.payload.passwordErrorMessage : state.passwordErrorMessage
      }
    case CHANGE_PASSWORD_CONFIRM:
      return {
        ...state,
        passwordConfirm: action.payload.passwordConfirm != null ? action.payload.passwordConfirm : state.passwordConfirm,
        passwordConfirmStatus: action.payload.passwordConfirmStatus != null ? action.payload.passwordConfirmStatus : state.passwordConfirmStatus,
      }
    case CHANGE_FIRST_NAME:
      return {
        ...state,
        firstname: action.payload.firstname != null ? action.payload.firstname : state.firstname,
        firstnameStatus: action.payload.firstnameStatus != null ? action.payload.firstnameStatus : state.firstnameStatus,
        firstnameErrorMessage: action.payload.firstnameErrorMessage != null ? action.payload.firstnameErrorMessage : state.firstnameErrorMessage
      }
    case CHANGE_SURNAME:
      return {
        ...state,
        surname: action.payload.surname != null ? action.payload.surname : state.surname,
        surnameStatus: action.payload.surnameStatus != null ? action.payload.surnameStatus : state.surnameStatus,
        surnameErrorMessage: action.payload.surnameErrorMessage != null ? action.payload.surnameErrorMessage : state.surnameErrorMessage
      }
    case CHANGE_BIRTH_DATE:
      return {
        ...state,
        day: action.payload.day != null ? action.payload.day : state.day,
        month: action.payload.month != null ? action.payload.month : state.month,
        year: action.payload.year != null ? action.payload.year : state.year,
        dateStatus: action.payload.dateStatus != null ? action.payload.dateStatus : state.dateStatus,
        dateErrorMessage: action.payload.dateErrorMessage != null ? action.payload.dateErrorMessage : state.dateErrorMessage
      }
    case VALIDATE_FORM_SUCCESS:
      const updatedField = action.payload.updatedField;

      return {
        ...state,
        usernameStatus: updatedField === 'username' ? 'success' : state.usernameStatus,
        usernameMessage: state.usernameMessage,
        passwordStatus: updatedField === 'password' ? 'success' : state.passwordStatus,
        passwordErrorMessage: state.passwordErrorMessage,
        firstnameStatus: updatedField === 'firstname' ? 'success' : state.firstnameStatus,
        firstnameErrorMessage: state.firstnameErrorMessage,
        surnameStatus: updatedField === 'surname' ? 'success' : state.surnameStatus,
        surnameErrorMessage: state.surnameErrorMessage,
        dateStatus: updatedField === 'birthdate' ? 'success' : state.dateStatus,
        dateErrorMessage: state.dateErrorMessage,
      }
    case VALIDATE_FORM_ERROR: {
      const validationErrors = action.payload.validationErrors;

      let formStatus = {};

      if (validationErrors != null) {

        if (isNotEmptyString(validationErrors.usernameError)) {
          formStatus.usernameStatus = 'error';
          formStatus.usernameMessage = validationErrors.usernameError;
        }
        if (isNotEmptyString(validationErrors.passwordError)) {
          formStatus.passwordStatus = 'error';
          formStatus.passwordErrorMessage = validationErrors.passwordError;
        }
        if (isNotEmptyString(validationErrors.firstNameError)) {
          formStatus.firstnameStatus = 'error';
          formStatus.firstnameErrorMessage = validationErrors.firstNameError;
        }
        if (isNotEmptyString(validationErrors.lastNameError)) {
          formStatus.surnameStatus = 'error';
          formStatus.surnameErrorMessage = validationErrors.lastNameError;
        }
        if (isNotEmptyString(validationErrors.birthDateError)) {
          formStatus.dateStatus = 'error';
          formStatus.dateErrorMessage = validationErrors.birthDateError;
        }
      } else {
        const { updatedField } = action.payload;
        const errorMessage = action.payload.error.message != null ? action.payload.error.message : '';

        if (updatedField) {
          switch (updatedField) {
            case 'username':
              formStatus.usernameStatus = 'error';
              formStatus.usernameMessage = errorMessage;
              break;
            case 'password':
              formStatus.passwordStatus = 'error';
              formStatus.passwordErrorMessage = errorMessage;
              break;
            case 'firstname':
              formStatus.firstnameStatus = 'error';
              formStatus.firstnameErrorMessage = errorMessage;
              break;
            case 'surname':
              formStatus.surnameStatus = 'error';
              formStatus.surnameErrorMessage = errorMessage;
              break;
            case 'birthDay':
            case 'birthMonth':
            case 'birthYear':
            case 'birthdate':
              formStatus.dateStatus = 'error';
              formStatus.dateErrorMessage = errorMessage;
              break;
            default:
              console.log(`Unknown field validation - ${updatedField}`);
              break;
          }
        }
      }

      return {
        ...state,
        usernameStatus: formStatus.usernameStatus,
        usernameMessage: formStatus.usernameMessage,
        passwordStatus: formStatus.passwordStatus,
        passwordErrorMessage: formStatus.passwordErrorMessage,
        firstnameStatus: formStatus.firstnameStatus,
        firstnameErrorMessage: formStatus.firstnameErrorMessage,
        surnameStatus: formStatus.surnameStatus,
        surnameErrorMessage: formStatus.surnameErrorMessage,
        dateStatus: formStatus.dateStatus,
        dateErrorMessage: formStatus.dateErrorMessage,
      }
    }
    case SET_INVALID_PROMOCODE:
      return {
        ...state,
        invalidPromocodeMessage: action.payload,
      }
    case UPDATE_COUNTRY:
      return {
        ...state,
        country: action.payload
      }
    case SET_MODAL_OPEN:
      return {
        ...state,
        modalOpen: action.payload,
        recoveryPasswordStatus: 0,
        recoveryPasswordMessage: '',
        isLoadingRecoveryPassword: false
      }
    case SEND_RECOVERY_PASSWORD:
      return {
        ...state,
        isLoadingRecoveryPassword: true,
        recoveryPasswordStatus: 0,
        recoveryPasswordMessage: '',
      }
    case SEND_RECOVERY_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoadingRecoveryPassword: false,
        recoveryPasswordStatus: 1,
        recoveryPasswordMessage: '',
      }
    case SEND_RECOVERY_PASSWORD_ERROR:
      return {
        ...state,
        isLoadingRecoveryPassword: false,
        recoveryPasswordStatus: -1,
        recoveryPasswordMessage: action.payload.message != null ? action.payload.message : 'Error. Contact Customer Service.',
      }
    case VALIDATE_AGENT_PROMOTION:
      return {
        ...state,
        isLoadingPromocodeCheck: true,
        isFormValidating: true,
      }
    case GET_USER_AND_INACTIVE_INFO:
      return {
        ...state,
        isLoadingMobileCheck: true,
        isFormValidating: true,
        deleteDormantClientStatus: 0,
        isLoadingDeleteDormantClient: false,
        deleteDormantClientMessage: '',
        deleteDormantClientEnabled: false,
      }
    case SUBMIT_CLIENT_FROM_SHOP:
      return {
        ...state,
        error: {},
        validationMessage: ''
      }
    case MAIN_HANDLE_PENDING_STATUS:
      return {
        ...state,
        isFormValidating: action.payload.isLoading,
        isLoadingUsernameCheck: action.payload.isLoading && action.payload.updatedField === 'username',
        isLoadingPasswordCheck: action.payload.isLoading && action.payload.updatedField === 'password',
        isLoadingFirstNameCheck: action.payload.isLoading && action.payload.updatedField === 'firstname',
        isLoadingSurnameCheck: action.payload.isLoading && action.payload.updatedField === 'surname',
        isLoadingDateOfBirthCheck: action.payload.isLoading && action.payload.updatedField === 'birthdate'
      }
    case CHANGE_TERMS_STATUS:
      return {
        ...state,
        termsStatus: action.payload,
      }
    case DELETE_LOGIPARMA_DORMANT_CLIENT:
      return {
        ...state,
        isLoadingDeleteDormantClient: true,
        deleteDormantClientStatus: 0,
        deleteDormantClientMessage: '',
        deleteDormantClientEnabled: true,
      }
    case DELETE_LOGIPARMA_DORMANT_CLIENT_SUCCESS:
      return {
        ...state,
        isLoadingDeleteDormantClient: false,
        deleteDormantClientStatus: 1,
        deleteDormantClientMessage: '',
        isLoadingMobileCheck: false,
        isFormValidating: false,
        mobileMessage: 'success',
        mobileUserInfo: null
      }
    case DELETE_LOGIPARMA_DORMANT_CLIENT_ERROR:
      return {
        ...state,
        isLoadingDeleteDormantClient: false,
        deleteDormantClientStatus: -1,
        deleteDormantClientMessage: action.payload.message != null ? action.payload.message : 'Error. Contact Customer Service.',
      }
    case OPEN_DELETE_DORMANT_CLIENT_POPUP:
      return {
        ...state,
        deleteDormantClientEnabled: true,
        modalOpen: true
      }
    case CLOSE_DELETE_DORMANT_CLIENT_POPUP:
      return {
        ...state,
        deleteDormantClientEnabled: false,
        modalOpen: false
      }
    default:
      return state;
  }
}


export const setEmail = createAction(SET_EMAIL);
export const setMobile = createAction(SET_MOBILE);
export const validateAgentPromotionAction = createAction(VALIDATE_AGENT_PROMOTION);
export const submitClientFromShop = createAction(SUBMIT_CLIENT_FROM_SHOP);
export const getUserAndInactiveInfo = createAction(GET_USER_AND_INACTIVE_INFO);
export const setEmailValidationData = createAction(SET_EMAIL_VALIDATION_DATA);
export const setTelephoneValidationData = createAction(SET_TELEPHONE_VALIDATION);

export const changeUsername = createAction(CHANGE_USERNAME);
export const changePassword = createAction(CHANGE_PASSWORD);
export const changeFirstname = createAction(CHANGE_FIRST_NAME);
export const changeSurname = createAction(CHANGE_SURNAME);
export const changeBirthDate = createAction(CHANGE_BIRTH_DATE);
export const validateForm = createAction(MAIN_VALIDATE_FORM);
export const resendActivationLink = createAction(RESEND_ACTIVATION_LINK);
export const setSuccessfulActivation = createAction(SET_SUCCESSFUL_ACTIVATION);
export const setReactivationData = createAction(SET_RESEND_ACTIVATION_DATA);
export const setPromocodeData = createAction(SET_PROMOCODE_VALIDATION_DATA);
export const setInvalidPromocode = createAction(SET_INVALID_PROMOCODE);
export const updateCountryAction = createAction(UPDATE_COUNTRY);
export const setErrorMessageAction = createAction(SET_ERROR_MESSAGE);
export const setModalOpenAction = createAction(SET_MODAL_OPEN);
export const sendRecoveryPasswordAction = createAction(SEND_RECOVERY_PASSWORD);
export const changePasswordConfirmAction = createAction(CHANGE_PASSWORD_CONFIRM);
export const changeTermsStatusAction = createAction(CHANGE_TERMS_STATUS);
export const deleteLogiParmaDormantClientAction = createAction(DELETE_LOGIPARMA_DORMANT_CLIENT);
export const openDormantClientPopupAction = createAction(OPEN_DELETE_DORMANT_CLIENT_POPUP);
export const closeDormantClientPopupAction = createAction(CLOSE_DELETE_DORMANT_CLIENT_POPUP);
